/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Grounding_Sleep_WhyInputs */

const en_us2_plan_build_grounding_sleep_why = /** @type {(inputs: Plan_Build_Grounding_Sleep_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Little sleep calls for less volume and more rest between sets.`)
};

const pt_br2_plan_build_grounding_sleep_why = /** @type {(inputs: Plan_Build_Grounding_Sleep_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pouco sono pede menos volume e mais descanso entre séries.`)
};

const es_419_plan_build_grounding_sleep_why = /** @type {(inputs: Plan_Build_Grounding_Sleep_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dormir poco pide menos volumen y más descanso entre series.`)
};

const pt_pt2_plan_build_grounding_sleep_why = /** @type {(inputs: Plan_Build_Grounding_Sleep_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pouco sono pede menos volume e mais descanso entre séries.`)
};

const fr_fr2_plan_build_grounding_sleep_why = /** @type {(inputs: Plan_Build_Grounding_Sleep_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peu de sommeil demande moins de volume et plus de repos entre les séries.`)
};

const de_de2_plan_build_grounding_sleep_why = /** @type {(inputs: Plan_Build_Grounding_Sleep_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenig Schlaf heißt weniger Volumen und mehr Pause zwischen den Sätzen.`)
};

const it_it2_plan_build_grounding_sleep_why = /** @type {(inputs: Plan_Build_Grounding_Sleep_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poco sonno richiede meno volume e più recupero tra le serie.`)
};

/**
* | output |
* | --- |
* | "Little sleep calls for less volume and more rest between sets." |
*
* @param {Plan_Build_Grounding_Sleep_WhyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_grounding_sleep_why = /** @type {((inputs?: Plan_Build_Grounding_Sleep_WhyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Grounding_Sleep_WhyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_grounding_sleep_why(inputs)
	if (locale === "es-419") return es_419_plan_build_grounding_sleep_why(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_grounding_sleep_why(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_grounding_sleep_why(inputs)
	if (locale === "de-DE") return de_de2_plan_build_grounding_sleep_why(inputs)
	if (locale === "it-IT") return it_it2_plan_build_grounding_sleep_why(inputs)
	return en_us2_plan_build_grounding_sleep_why(inputs)
});
export { plan_build_grounding_sleep_why as "plan-build.grounding_sleep_why" }